export class TosTosDesc {
  tos: string;
  tosdesc: string;

  //for GUI use
  selected?: string;
}
